import { createFileRoute, redirect } from '@tanstack/react-router';
import { ASSET_ROUTE_URL, TRADE_ROUTE_URL } from '../../constants/routes';
import { defaultSelectedTicker } from '../../lib/config';

/**
 * Index route for /trade (redirect to ASSET_ROUTE_URL).
 */
export const Route = createFileRoute(TRADE_ROUTE_URL)({
  component: Index,
  beforeLoad: () => {
    throw redirect({
      to: ASSET_ROUTE_URL,
      params: { asset: defaultSelectedTicker },
      replace: true,
    });
  },
});

function Index() {
  return null; // This won't be rendered due to the redirect
}
